module.exports = __webpack_public_path__ + "assets/img/24_425_big.5894e349.jpg";